import React from "react";

export default function influecerList() {
  return (
    <React.Fragment>
      <div className="container-main">
        <div>List All Influencers</div>
      </div>
    </React.Fragment>
  );
}
